import {
  AppHandledException,
  INVALID_SIGNATURE_DOCUMENT_EXCEPTION,
  INVALID_SIGNATURE_DOCUMENT_URL_KEY
} from 'core/constants/exceptions'
import getAndParseDocument from './get-and-parse-document'
import getAndParseQuote from './get-and-parse-quote'
import getURLParams from 'utils/DOM/getURLParams'
import validate from './validate'
import { LoadSignatureDocumentParams } from './types'

const stopFlow = (description: string) => {
  const appException: AppHandledException = {
    _tag: 'AppHandledException',
    type: INVALID_SIGNATURE_DOCUMENT_EXCEPTION,
    key: INVALID_SIGNATURE_DOCUMENT_URL_KEY,
    details: {
      description
    }
  }

  throw appException
}

async function loadSignatureDocument({ tryLoad }: LoadSignatureDocumentParams) {
  if (tryLoad) {
    const queryParams = getURLParams()
    const documentId = queryParams['document_id']
    const agentId = queryParams['agent_id']

    // If the documentId or agentId is not present in the URL, return undefined to avoid interrupting the flow
    if (!documentId || !agentId) return undefined

    const [signatureDocError, signatureDocument] = await getAndParseDocument({
      documentId,
      agentId
    })
    if (signatureDocError) {
      stopFlow('Error loading signature document from the server')
    }

    const [quoteError, quote] = await getAndParseQuote(
      signatureDocument.hcStorage.quoteKey
    )
    if (quoteError) {
      stopFlow('Error loading quote from the server')
    }

    const result = {
      ...signatureDocument,
      quote
    }
    const validateResult = validate(result)
    if (validateResult) {
      stopFlow(validateResult)
    }

    // Return the complete signature document
    return result
  }
}

export default loadSignatureDocument
